import React, {useCallback, useEffect, useState} from 'react'
/**
 * A hook to see if user scrolls in certain DOM element using `element reference`
 *
 */
export const useScrollDetector = (
  elementRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  const [isScrolling, setIsScrolling] = useState(false)
  const element = elementRef.current

  const handleScroll = useCallback(() => {
    if (element) {
      setIsScrolling(element.scrollTop > 0)
    }
  }, [element])

  useEffect(() => {
    // Attach the scroll event listener to the specified element
    if (element) {
      element.addEventListener('scroll', handleScroll)
    }

    return () => {
      // Remove the scroll event listener when the component is unmounted
      if (element) {
        element.removeEventListener('scroll', handleScroll)
      }
    }
  }, [element, handleScroll])

  return isScrolling
}
